import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter 703 (Kamel) — 🖼️ affiches « Espagne 2027 » sous l'accueil, tout est réglé dans l'admin (Site internet → Accueil)
export const AffichesAccueil = () => {
  const [cfg, setCfg] = useState(null);
  const [zoom, setZoom] = useState(null);
  useEffect(() => { axios.get(`${API}/accueil/affiches`).then(r => setCfg(r.data)).catch(() => setCfg(null)); }, []);
  useEffect(() => {
    if (!zoom) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setZoom(null); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [zoom]);
  if (!cfg || !cfg.actif || !cfg.affiches?.length) return null;
  const externe = /^https?:\/\//i.test(cfg.bouton_lien || '');
  const deux = cfg.affiches.length === 2;
  return (
    <section className="bg-[#F7F3EA] py-10 md:py-14" data-testid="affiches-accueil">
      <div className="container-custom">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <p className="text-[11px] font-black tracking-[0.2em] uppercase text-[#C60B1E] mb-3">Rhône Alpes Amitié Voyages</p>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1E3A5F] mb-4" data-testid="affiches-accueil-titre">{cfg.titre}</h2>
            {cfg.texte && <p className="text-base md:text-lg text-gray-700 leading-relaxed whitespace-pre-line max-w-xl mx-auto lg:mx-0" data-testid="affiches-accueil-texte">{cfg.texte}</p>}
            {cfg.bouton_label && cfg.bouton_lien && (externe
              ? <a href={cfg.bouton_lien} target="_blank" rel="noopener noreferrer" className="inline-block mt-6 bg-[#1E3A5F] text-white px-7 py-3.5 rounded-xl font-bold hover:bg-[#2a4f7a] transition shadow-lg" data-testid="affiches-accueil-bouton">{cfg.bouton_label}</a>
              : <Link to={cfg.bouton_lien} onClick={() => window.scrollTo(0, 0)} className="inline-block mt-6 bg-[#1E3A5F] text-white px-7 py-3.5 rounded-xl font-bold hover:bg-[#2a4f7a] transition shadow-lg" data-testid="affiches-accueil-bouton">{cfg.bouton_label}</Link>)}
          </div>
          <div className={`grid gap-5 ${deux ? 'grid-cols-2' : cfg.affiches.length === 1 ? 'grid-cols-1' : 'grid-cols-2 md:grid-cols-3'} flex-shrink-0 w-full lg:w-auto lg:max-w-[560px]`}>
            {cfg.affiches.map((a, i) => (
              <button key={a.id} type="button" onClick={() => setZoom(a)} className={`group relative rounded-2xl overflow-hidden shadow-xl bg-white transition-transform hover:-translate-y-1 hover:rotate-0 ${deux ? (i === 0 ? 'lg:-rotate-2' : 'lg:rotate-2 lg:mt-8') : ''}`} data-testid={`affiche-accueil-${i}`} aria-label={a.legende || `Affiche ${i + 1}`}>
                <img src={`${API}/accueil/affiches/${a.id}.jpg`} alt={a.legende || `Affiche ${i + 1}`} loading="lazy" className="w-full h-auto block" />
                <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent text-white text-xs px-3 py-2 text-left opacity-0 group-hover:opacity-100 transition-opacity">🔍 Agrandir</span>
              </button>
            ))}
          </div>
        </div>
      </div>
      {zoom && (
        <div className="fixed inset-0 z-[1200] bg-black/85 flex items-center justify-center p-4" onClick={() => setZoom(null)} data-testid="affiche-accueil-zoom">
          <img src={`${API}/accueil/affiches/${zoom.id}.jpg`} alt={zoom.legende || 'Affiche'} className="max-h-[92vh] max-w-full rounded-xl shadow-2xl" onClick={e => e.stopPropagation()} />
          <button type="button" onClick={() => setZoom(null)} className="absolute top-4 right-4 text-white text-3xl leading-none" aria-label="Fermer" data-testid="affiche-accueil-zoom-fermer">×</button>
        </div>
      )}
    </section>
  );
};

export default AffichesAccueil;
